import React, { useEffect, useContext, useState, useRef } from "react";
import { AppContext } from "../../AppContext";
import AuthService from "../../AuthService";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Update from "@material-ui/icons/Update";
import AccountCircle from "@material-ui/icons/AccountCircle";
import AccountBalance from "@material-ui/icons/AccountBalance";
import Photo from "@material-ui/icons/Photo";
import BubbleChart from "@material-ui/icons/BubbleChart";
import List from "@material-ui/icons/List";
import Autorenew from "@material-ui/icons/Autorenew";
import Public from "@material-ui/icons/Public";
import MoneyOff from "@material-ui/icons/MoneyOff";
import AttachMoney from "@material-ui/icons/AttachMoney";
import People from "@material-ui/icons/People";
import CardGiftcard from "@material-ui/icons/CardGiftcard";
import CreditCardIcon from "@material-ui/icons/CreditCardOutlined";
import MmsIcon from "@material-ui/icons/Mms";
import CameraIcon from "@material-ui/icons/Camera";
import BlockOutlined from "@material-ui/icons/BlockOutlined";
import RedeemIcon from "@material-ui/icons/RedeemOutlined";
import WalletIcon from "@material-ui/icons/AccountBalanceWalletOutlined";
// Core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
// Charts
import { Chart } from "react-google-charts";
// Autocomplete
import Autosuggest from "react-autosuggest";

import "./autocomplete.css";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();

  const context = useContext(AppContext);

  const [postCount, setPostCount] = useState([]);
  const [currency, setCurrency] = React.useState({ code: "eur", symbol: "€" });
  const [globalAverageSaleValuesCurrency, setGlobalAverageSaleValuesCurrency] = React.useState({ code: "eur", symbol: "€" });
  const [arpuCurrency, setArpuCurrency] = React.useState({ code: "eur", symbol: "€" });
  const [currencies, setCurrencies] = React.useState([]);
  const [activeSubscriptionsCount, setActiveSubscriptionsCount] = useState(0);
  const [activeFreeSubscriptionsCount, setActiveFreeSubscriptionsCount] = useState(0);
  const [activePaidSubscriptionsCount, setActivePaidSubscriptionsCount] = useState(0);
  const [fansWithSubsCount, setFansWithSubsCount] = useState(0);
  const [fansWithFreeSubsCount, setFansWithFreeSubsCount] = useState(0);
  const [fansWithPaidSubsCount, setFansWithPaidSubsCount] = useState(0);
  const [connectedFansSelectedMonthCount, setConnectedFansSelectedMonthCount] = useState(0);
  const [connectedModelsSelectedMonthCount, setConnectedModelsSelectedMonthCount] = useState(0);
  const [connectedUsersCountUpdatedAt, setConnectedUsersCountUpdatedAt] = useState("");
  const [connectedCountersYear, setConnectedCountersYear] = useState(new Date().getFullYear());
  const [connectedCountersMonth, setConnectedCountersMonth] = useState(new Date().getMonth() + 1);

  const [transactionsCounters, setTransactionsCounters] = useState({});
  const [incomeSource, setIncomeSource] = useState("All");
  const [incomes, setIncomes] = useState({agencies: 0, bank: 0, godfathers: 0, models: 0, platform: 0, promoters: 0, superGodFathers: 0, total: 0});
  const [pspSource, setPspSource] = useState("All");
  const [yearFilter, setYearFilter] = useState(new Date().getFullYear());
  const [monthFilter, setMonthFilter] = useState(new Date().getMonth() + 1);
  const [arpuYearFilter, setArpuYearFilter] = useState(new Date().getFullYear());
  const [arpuMonthFilter, setArpuMonthFilter] = useState(new Date().getMonth() + 1);
  const [modelName, setModelName] = useState("");
  const [modelSuggestions, setModelSuggestions] = useState([]);
  const [countModel, setCountModel] = useState(0);
  const [countGodfather, setCountGodfather] = useState(0);
  const [countPromoters, setCountPromoters] = useState(0);
  const [countSuperGodFathers, setCountSuperGodFathers] = useState(0);
  const [countAgency, setCountAgency] = useState(0);
  const [countAsso, setCountAsso] = useState(0);
  const [countFan, setCountFan] = useState(0);
  const [countModelDeleted, setCountModelDeleted] = useState(0);
  const [countFanDeleted, setCountFanDeleted] = useState(0);
  // const [countAmbassador, setCountAmbassador] = useState(0);
  const [countNetworks, setCountNetworks] = useState(0);
  const [updateSent, setUpdateSent] = useState(false);
  const [clients, setClients] = useState(false);
  const [globalAverageSaleValues, setGlobalAverageSaleValues] = useState({buyPrivateMedia: 0, buyMediaOnDemand: 0, tip: 0, tipLive: 0, subscription: 0, meeting: 0, live: 0, total: 0});
  const [averageSaleValues, setAverageSaleValues] = useState({buyPrivateMedia: 0, buyMediaOnDemand: 0, tip: 0, tipLive: 0, subscription: 0, meeting: 0, live: 0, total: 0});
  const [arpu, setArpu] = useState({ arpu: 0, fansCount: 0 });

  useEffect(() => {
    const authService = new AuthService();

    // Get all clients connected
    authService.setUrl(context.apiUrl + context.liveNotifierPath + "clients");
    authService.request("get", {}, (response) => {
      const { data } = response;
      setClients(data.clients ? data.clients : 0);
    });

    // Get all users
    authService.setUrl(context.apiUrl + context.usersHonoPath + "counters");
    authService.request("get", {}, (response) => {
      const { data } = response;
      setCountFan(data.fan);
      setCountModel(data.model);
      setCountGodfather(data.godfather);
      setCountPromoters(data.promoter);
      setCountAgency(data.agency);
      setCountSuperGodFathers(data.superGodFather);
      setCountAsso(data.asso);
      setCountFanDeleted(data.fanDeleted);
      setCountModelDeleted(data.modelDeleted);
    });

    // Get all ambassadors
    // authService.setUrl(context.apiUrl + context.ambassadorsPath + "all");
    // authService.request("get", {}, response => {
    //   const { data } = response;
    //   const listAmbasssadors = data.map(ambassador => ambassador);
    //   setCountAmbassador(listAmbasssadors.length);
    // });

    // Get all social network
    authService.setUrl(context.apiUrl + context.socialNetworksPath);
    authService.request("get", {}, (response) => {
      const { data } = response;
      if (data && Array.isArray(data)) {
        let count = data.map((e) => e.followers).reduce((a, b) => a + b);
        setCountNetworks(numberWithSpaces(Math.round(count)));
      }
    });

    // Get post count
    authService.setUrl(context.apiUrl + context.postsHonoPath + "count");
    authService.request("get", {}, (response) => {
      const { data } = response;
      setPostCount(data.count);
    });

    getGlobalAverageSaleValues();
    getAverageSaleValues();
    getArpu();
    getSubscribers();
  }, []);

  const getSubscribers = () => {
    const authService = new AuthService();
    // Get subscriptions
    authService.setUrl(context.apiUrl + context.subscribeHonoPath + "counters");
    authService.request("get", {}, (response) => {
      const { data } = response;
      setActiveSubscriptionsCount(data.count);
      setActiveFreeSubscriptionsCount(data.freeSubCount);
      setActivePaidSubscriptionsCount(data.paidSubCount);
      setFansWithSubsCount(data.fanWithSubCount);
      setFansWithFreeSubsCount(data.fanWithFreeSubCount);
      setFansWithPaidSubsCount(data.fanWithPaidSubCount);
    });
  };

  const getUsersCounters = () => {
    const authService = new AuthService();
    authService.setUrl(context.apiUrl + context.usersHonoPath + "counters/connected");
    authService.request(
      "get",
      { month: connectedCountersMonth, year: connectedCountersYear },
      (response) => {
        const { data } = response;
        setConnectedFansSelectedMonthCount(data.connectedInMonthFan ?? 0);
        setConnectedModelsSelectedMonthCount(data.connectedInMonthModel ?? 0);
        setConnectedUsersCountUpdatedAt(
          data.computedAt ? new Date(data.computedAt).toLocaleString() : "—"
        );
      }
    );
  };

  useEffect(() => {
    getUsersCounters();
  }, [connectedCountersMonth, connectedCountersYear]);

  useEffect(() => {
    getCurrencies();
  }, []);

  useEffect(() => {
    getAllIncomes();
    getTransactionsCounters();
    getAverageSaleValues();
  }, [pspSource, incomeSource, modelName, monthFilter, yearFilter, currency]);

  useEffect(() => {
    getGlobalAverageSaleValues();
  }, [globalAverageSaleValuesCurrency]);

  useEffect(() => {
    getArpu();
  }, [arpuCurrency, arpuYearFilter, arpuMonthFilter]);

  const getCurrencies = () => {
    const authService = new AuthService();

    authService.setUrl(
      context.apiUrl + context.categoriesPath + "currencies/all"
    );
    authService.request("get", {}, (response) => {
      const { data } = response;
      if (data && Array.isArray(data)) {
        setCurrencies(data.filter(item => item.active === true));
      }
    });
  };

  const getAllIncomes = () => {
    const authService = new AuthService();

    authService.setUrl(context.apiUrl + context.transactionsHonoPath + "incomes");
    authService.request(
      "get",
      {
        psp: pspSource,
        month: monthFilter ? monthFilter : "All",
        year: yearFilter ? yearFilter : "All",
        currency: currency.code,
      },
      (response) => {
        const incomes = response.data;
        setIncomes({
          agencies: incomes.agencies ? incomes.agencies : 0,
          bank: incomes.bank ? incomes.bank : 0,
          godfathers: incomes.godfathers ? incomes.godfathers : 0,
          models: incomes.models ? incomes.models : 0,
          platform: incomes.platform ? incomes.platform : 0,
          promoters: incomes.promoters ? incomes.promoters : 0,
          superGodFathers: incomes.superGodFathers ? incomes.superGodFathers : 0,
          total: incomes.total ? incomes.total : 0,
        });
      }
    );
  };

  const getTransactionsCounters = () => {
    const authService = new AuthService();

    authService.setUrl(context.apiUrl + context.transactionsHonoPath + "counters");
    authService.request(
      "get",
      {
        income: incomeSource,
        psp: pspSource,
        username: modelName,
        month: monthFilter ? monthFilter : "All",
        year: yearFilter ? yearFilter : "All",
        currency: currency.code,
      },
      (response) => {
        var transactionsCounters = response.data;
        if (transactionsCounters) {
          setTransactionsCounters(transactionsCounters);
        }
      }
    );
  };

  const getGlobalAverageSaleValues = () => {
    const authService = new AuthService();
    authService.setUrl(context.apiUrl + context.usersHonoPath + `averageSaleValue?currency=${globalAverageSaleValuesCurrency.code}&month=all&year=all`);
    authService.request("get", {}, (response) => {
      const { data } = response;
      setGlobalAverageSaleValues(data);
    });
  };

  const getAverageSaleValues = () => {
    const authService = new AuthService();
    authService.setUrl(context.apiUrl + context.usersHonoPath + `averageSaleValue?currency=${currency.code}&month=${monthFilter !== 0 ? monthFilter : "all"}&year=${yearFilter !== "All" ? yearFilter : "all"}`);
    authService.request("get", {}, (response) => {
      const { data } = response;
      setAverageSaleValues(data);
    });
  };

  const getArpu = () => {
    const authService = new AuthService();
    authService.setUrl(context.apiUrl + context.transactionsHonoPath + `arpu?currency=${arpuCurrency.code}&month=${arpuMonthFilter !== 0 ? arpuMonthFilter : new Date().getMonth() + 1}&year=${arpuYearFilter !== "All" ? arpuYearFilter : new Date().getFullYear()}`);
    authService.request("get", {}, (response) => {
      const { data } = response;
      setArpu(data);
    });
  }

  const numberWithSpaces = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const handleIncomeSourceChange = (event) => {
    setIncomeSource(event.target.value);
  };

  const handleCurrencyChange = (event) => {
    let index = currencies.map((e) => e.code).indexOf(event.target.value);
    setCurrency(currencies[index]);
  };

  const handleGlobalAverageSaleValuesCurrencyChange = (event) => {
    let index = currencies.map((e) => e.code).indexOf(event.target.value);
    setGlobalAverageSaleValuesCurrency(currencies[index]);
  };

  const handleArpuCurrencyChange = (event) => {
    let index = currencies.map((e) => e.code).indexOf(event.target.value);
    setArpuCurrency(currencies[index]);
  };

  const handlePspSourceChange = (event) => {
    setPspSource(event.target.value);
  };

  const handleYearChange = (event) => {
    setYearFilter(event.target.value);
  };

  const handleMonthChange = (event) => {
    setMonthFilter(event.target.value);
  };

  const handleArpuYearChange = (event) => {
    setArpuYearFilter(event.target.value);
  };

  const handleArpuMonthChange = (event) => {
    setArpuMonthFilter(event.target.value);
  };

  const handleConnectedCountersYearChange = (event) => {
    setConnectedCountersYear(event.target.value);
  };

  const handleConnectedCountersMonthChange = (event) => {
    setConnectedCountersMonth(event.target.value);
  };

  const handleModelNameChange = (event) => {
    var userName = event.target.value;
    if (userName != undefined) {
      const authService = new AuthService();

      setModelName(userName);

      // Get all categories
      authService.setUrl(context.apiUrl + context.usersHonoPath + "suggestion");
      authService.request(
        "get",
        {
          name: userName,
          show: "all",
          age: "[18,60]",
          distance: 100,
        },
        (response) => {
          const { data } = response;
          setModelSuggestions(data);
        }
      );
    }
  };

  // When the input is focused, Autosuggest will consult this function when to render suggestions.
  // Use it, for example, if you want to display suggestions when input value is at least 2 characters long.
  const shouldRenderSuggestions = (value) => {
    if (value && value.length >= 1) {
      return true;
    }
  };

  const onSuggestionSelected = (event, data) => {
    setModelName(data.suggestionValue);
  };

  const inputProps = {
    placeholder: "Model name",
    onChange: handleModelNameChange,
    value: modelName,
  };

  var date = new Date();

  const {
    buyPrivateMedia,
    buyMediaOnDemand,
    subscription,
    meeting,
    live,
    tip,
    tipLive,
    refund,
    recharge,
    total,
    count,
  } = transactionsCounters;

  let incomeChatMedia = buyPrivateMedia ? buyPrivateMedia.total : 0;
  let nbChatMediaTransactions = buyPrivateMedia ? buyPrivateMedia.count : 0;
  let incomeMod = buyMediaOnDemand ? buyMediaOnDemand.total : 0;
  let nbModTransactions = buyMediaOnDemand ? buyMediaOnDemand.count : 0;
  let incomeMeetings = meeting ? meeting.total : 0;
  let nbMeetingTransactions = meeting ? meeting.count : 0;
  let incomeLives = live ? live.total : 0;
  let nbLiveTransactions = live ? live.count : 0;
  let incomeSubscription = subscription ? subscription.total : 0;
  let nbSubscriptionCount = subscription ? subscription.count : 0;
  let incomeTip = tip ? tip.total : 0;
  let nbTipCount = tip ? tip.count : 0;
  let incomeTipLive = tipLive ? tipLive.total : 0;
  let nbTipLiveCount = tipLive ? tipLive.count : 0;
  let incomeRecharge = recharge ? recharge.total : 0;
  let nbRechargeCount = recharge ? recharge.count : 0;
  let incomeRefund = refund ? refund.total : 0;
  let nbRefunds = refund ? refund.count : 0;
  let totalIncome = total ? total : 0;
  let totalTransactions = count ? count : 0;
  let startingDate = 2020;
  let yearList = ["All"];
  for (let i = startingDate; i <= new Date().getFullYear(); ++i) {
    yearList.push(i);
  }

  let monthList = [
    "All",
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  return (
    <div>

      <h4 style={{ margin: "0px" }}>Users</h4>

      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Fans</p>
              <h3 className={classes.cardTitle}>{countFan}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Models</p>
              <h3 className={classes.cardTitle}>{countModel}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Godfathers</p>
              <h3 className={classes.cardTitle}>{countGodfather}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Promoters</p>
              <h3 className={classes.cardTitle}>{countPromoters}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Agencies</p>
              <h3 className={classes.cardTitle}>{countAgency}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Super godfathers</p>
              <h3 className={classes.cardTitle}>{countSuperGodFathers}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Asso</p>
              <h3 className={classes.cardTitle}>{countAsso}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Fans deleted</p>
              <h3 className={classes.cardTitle}>{countFanDeleted}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <AccountCircle />
              </CardIcon>
              <p className={classes.cardCategory}>Models deleted</p>
              <h3 className={classes.cardTitle}>{countModelDeleted}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>


      <h4 style={{ margin: "0px" }}>Posts</h4>

      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Photo />
              </CardIcon>
              <p className={classes.cardCategory}>Count</p>
              <h3 className={classes.cardTitle}>{postCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <h4 style={{ margin: "0px" }}>Connections</h4>

      <FormControl className={classes.formControl}>
        <InputLabel>Year</InputLabel>
        <Select onChange={handleConnectedCountersYearChange} value={connectedCountersYear}>
          {yearList.slice(1).map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Month</InputLabel>
        <Select onChange={handleConnectedCountersMonthChange} value={connectedCountersMonth}>
          {monthList.slice(1).map((month, index) => (
            <MenuItem key={month} value={index + 1}>
              {month}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Public />
              </CardIcon>
              <p className={classes.cardCategory}>Fans</p>
              <h3 className={classes.cardTitle}>{connectedFansSelectedMonthCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {connectedUsersCountUpdatedAt}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Public />
              </CardIcon>
              <p className={classes.cardCategory}>Creators</p>
              <h3 className={classes.cardTitle}>{connectedModelsSelectedMonthCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {connectedUsersCountUpdatedAt}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Public />
              </CardIcon>
              <p className={classes.cardCategory}>Current</p>
              <h3 className={classes.cardTitle}>{clients}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <h4 style={{ margin: "0px" }}>Subscriptions</h4>

      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <Autorenew />
              </CardIcon>
              <p className={classes.cardCategory}>Total Subscriptions</p>
              <h3 className={classes.cardTitle}>{activeSubscriptionsCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <MoneyOff />
              </CardIcon>
              <p className={classes.cardCategory}>Free Subscriptions</p>
              <h3 className={classes.cardTitle}>{activeFreeSubscriptionsCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AttachMoney />
              </CardIcon>
              <p className={classes.cardCategory}>Paid Subscriptions</p>
              <h3 className={classes.cardTitle}>{activePaidSubscriptionsCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <People />
              </CardIcon>
              <p className={classes.cardCategory}>Fans with sub</p>
              <h3 className={classes.cardTitle}>{fansWithSubsCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <MoneyOff />
              </CardIcon>
              <p className={classes.cardCategory}>Fans with free sub</p>
              <h3 className={classes.cardTitle}>{fansWithFreeSubsCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <AttachMoney />
              </CardIcon>
              <p className={classes.cardCategory}>Fans with paid sub</p>
              <h3 className={classes.cardTitle}>{fansWithPaidSubsCount}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <h4 style={{ margin: "0px" }}>Global Average Sale Values</h4>
      <FormControl className={classes.formControl}>
        <InputLabel>Currency</InputLabel>
        <Select onChange={handleGlobalAverageSaleValuesCurrencyChange} value={globalAverageSaleValuesCurrency.code}>
          {currencies.map((currency) => (
            <MenuItem value={currency.code}>{currency.code}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Media On Demand</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.buyMediaOnDemand} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
              <p
                style={{
                  width: "56px",
                  height: "58px",
                  fontSize: "30px",
                  lineHeight: "30px",
                  fontWeight: "bold",
                  margin: "0px",
                  padding: "0px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Private Media</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.buyPrivateMedia} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>


        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Meeting</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.meeting ?? 0} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Live</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.live ?? 0} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>


        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Subscriptions</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.subscription} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Tips</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.tip ?? 0} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Tips Live</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.tipLive ?? 0} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={3}>
          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <p
                  style={{
                    width: "56px",
                    height: "58px",
                    fontSize: "30px",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    margin: "0px",
                    padding: "0px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {globalAverageSaleValuesCurrency.symbol}
                </p>
              </CardIcon>
              <p className={classes.cardCategory}>Total</p>
              <h3 className={classes.cardTitle}>{globalAverageSaleValues.total} {globalAverageSaleValuesCurrency.symbol}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <FormControl className={classes.formControl}>
        <InputLabel>PSP</InputLabel>
        <Select onChange={handlePspSourceChange} value={pspSource}>
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="securionpay">Securion Pay</MenuItem>
          <MenuItem value="epoch">Epoch</MenuItem>
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Currency</InputLabel>
        <Select onChange={handleCurrencyChange} value={currency.code}>
          {currencies.map((currency) => (
            <MenuItem value={currency.code}>{currency.code}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Year</InputLabel>
        <Select onChange={handleYearChange} value={yearFilter}>
          {yearList.map((year) => (
            <MenuItem value={year}>{year}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Month</InputLabel>
        <Select onChange={handleMonthChange} value={monthFilter}>
          {monthList.map((month, index) => (
            <MenuItem value={index}>{month}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <h4 style={{ margin: "20px 0px 0px 0px" }}>Average Sale Values</h4>
      <GridContainer>
        {Object.keys(averageSaleValues).sort().map((key) => (
          <GridItem xs={6} sm={4} md={2} lg={2}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="warning" style={{ background: "#D4AF37" }}>
                  <p
                    style={{
                      fontSize: "30px",
                      lineHeight: "30px",
                      fontWeight: "bold",
                      margin: "0px",
                    }}
                  >
                    {currency.symbol}
                  </p>
                </CardIcon>
                <p className={classes.cardCategory}>{key}</p>
                <h3 className={classes.cardTitle}>{averageSaleValues[key]}</h3>
              </CardHeader>
            </Card>
          </GridItem>
        ))}
      </GridContainer>

      <h4 style={{ margin: "0px" }}>Incomes</h4>
      <GridContainer>
        {Object.keys(incomes).sort().map((key) => (
          <GridItem xs={6} sm={4} md={2} lg={2}>
            <Card>
              <CardHeader color="info" stats icon>
                <CardIcon color="warning" style={{ background: "#D4AF37" }}>
                  <p
                    style={{
                      fontSize: "30px",
                      lineHeight: "30px",
                      fontWeight: "bold",
                      margin: "0px",
                    }}
                  >
                    {currency.symbol}
                  </p>
                </CardIcon>
                <p className={classes.cardCategory}>{key}</p>
                <h3 className={classes.cardTitle}>{incomes[key]?.toLocaleString('fr-FR')}</h3>
              </CardHeader>
            </Card>
          </GridItem>
        ))}
      </GridContainer>

      <h4 style={{ margin: "0px" }}>ARPU</h4>
      <FormControl className={classes.formControl}>
        <InputLabel>Currency</InputLabel>
        <Select onChange={handleArpuCurrencyChange} value={arpuCurrency.code}>
          {currencies.map((currency) => (
            <MenuItem value={currency.code}>{currency.code}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Year</InputLabel>
        <Select onChange={handleArpuYearChange} value={arpuYearFilter}>
          {yearList.slice(1).map((year) => (
            <MenuItem value={year}>{year}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Month</InputLabel>
        <Select onChange={handleArpuMonthChange} value={arpuMonthFilter}>
          {monthList.slice(1).map((month, index) => (
            <MenuItem value={index + 1}>{month}</MenuItem>
          ))}
        </Select>
      </FormControl>

      {(arpu.arpu !== 0 || arpu.fansCount !== 0) && (
        <GridContainer>
          {Object.keys(arpu).sort().map((key) => (
            <GridItem xs={6} sm={4} md={2} lg={2}>
              <Card>
                <CardHeader color="info" stats icon>
                  <CardIcon color="warning" style={{ background: "#D4AF37" }}>
                    <p
                      style={{
                        fontSize: "30px",
                        lineHeight: "30px",
                        fontWeight: "bold",
                        margin: "0px",
                      }}
                    >
                      {arpuCurrency.symbol}
                    </p>
                  </CardIcon>
                  <p className={classes.cardCategory}>{key}</p>
                  <h3 className={classes.cardTitle}>{arpu[key]}</h3>
                </CardHeader>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      )}

      {/*
      <FormControl className={classes.formControl}>
        <InputLabel>Income</InputLabel>
        <Select onChange={handleIncomeSourceChange} value={incomeSource}>
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="platform">Platform</MenuItem>
          <MenuItem value="models">Models</MenuItem>
          <MenuItem value="godfathers">Godfathers</MenuItem>
          <MenuItem value="promoters">Promoters</MenuItem>
          <MenuItem value="agencies">Agencies</MenuItem>
          <MenuItem value="superGodFathers">Super godfathers</MenuItem>
          <MenuItem value="bank">Bank</MenuItem>
          <MenuItem value="wallets">Wallets</MenuItem>
          <MenuItem value="bonus">Bonus</MenuItem>
        </Select>
      </FormControl> */}

      {/* <FormControl className={classes.formControl}>
        <Autosuggest
          suggestions={modelSuggestions.filter(
            (e) => e?.toLowerCase().indexOf(modelName?.toLowerCase()) !== -1
          )}
          onSuggestionsFetchRequested={() => {}}
          onSuggestionsClearRequested={() => {}}
          onSuggestionSelected={onSuggestionSelected}
          getSuggestionValue={(suggestion) => suggestion}
          shouldRenderSuggestions={shouldRenderSuggestions}
          renderSuggestion={(elmt) => <span>{elmt}</span>}
          inputProps={inputProps}
        />
      </FormControl> */}

      <FormControl className={classes.formControl}>
        <InputLabel>Currency</InputLabel>
        <Select onChange={handleCurrencyChange} value={currency.code}>
          {currencies.map((currency) => (
            <MenuItem value={currency.code}>{currency.code}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Year</InputLabel>
        <Select onChange={handleYearChange} value={yearFilter}>
          {yearList.map((year) => (
            <MenuItem value={year}>{year}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl className={classes.formControl}>
        <InputLabel>Month</InputLabel>
        <Select onChange={handleMonthChange} value={monthFilter}>
          {monthList.map((month, index) => (
            <MenuItem value={index}>{month}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <GridContainer>
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="info" stats icon>
              <p className={classes.cardCategory}>
                Transactions ({totalTransactions})
              </p>
              <h3 className={classes.cardTitle}>
                <span className={classes.titleHighlighted}>
                  {totalIncome} {currency.symbol}
                </span>
              </h3>
            </CardHeader>
            <CardBody>
              <Chart
                width={"100%"}
                height={"300px"}
                chartType="PieChart"
                loader={<div>Loading Chart</div>}
                data={[
                  ["Type", "Incomes"],
                  [
                    "Abonnements " + incomeSubscription + " " + currency.symbol,
                    incomeSubscription,
                  ],
                  [
                    "Achat de médias " + incomeChatMedia + " " + currency.symbol,
                    incomeChatMedia,
                  ],
                  [
                    "MOD " + incomeMod + " " + currency.symbol,
                    incomeMod,
                  ],
                  ["Meeting " + incomeMeetings + " " + currency.symbol, incomeMeetings],
                  ["Live " + incomeLives + " " + currency.symbol, incomeLives],
                  ["Tip " + incomeTip + " " + currency.symbol, incomeTip],
                  ["Tip Live " + incomeTipLive + " " + currency.symbol, incomeTipLive],
                  [
                    "Recharge " + incomeRecharge + " " + currency.symbol,
                    incomeRecharge,
                  ],
                ]}
                options={{
                  title: "Transactions",
                  legend: "none",
                  pieHole: 0.4,
                  slices: {
                    0: { color: "#E73E3A" },
                    1: { color: "#3CB8CC" },
                    2: { color: "#DF2869" },
                    3: { color: "#942BAE" },
                    4: { color: "#4FA954" },
                  },
                }}
                rootProps={{ "data-testid": "3" }}
              />
            </CardBody>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="danger" stats icon>
              <CardIcon color="danger">
                <CreditCardIcon />
              </CardIcon>
              <p className={classes.cardCategory}>
                Abonnements ({nbSubscriptionCount})
              </p>
              <h3 className={classes.cardTitle}>
                {incomeSubscription?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          <Card>
            <CardHeader color="info" stats icon>
              <CardIcon color="info">
                <MmsIcon />
              </CardIcon>
              <p className={classes.cardCategory}>
                Achat de médias ({nbChatMediaTransactions})
              </p>
              <h3 className={classes.cardTitle}>
                {incomeChatMedia?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          <Card>
            <CardHeader color="rose" stats icon>
              <CardIcon color="rose">
                <MmsIcon />
              </CardIcon>
              <p className={classes.cardCategory}>
                MOD ({nbModTransactions})
              </p>
              <h3 className={classes.cardTitle}>
                {incomeMod?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          <Card>
            <CardHeader color="primary" stats icon>
              <CardIcon color="primary">
                <CameraIcon />
              </CardIcon>
              <p className={classes.cardCategory}>
                Meeting ({nbMeetingTransactions})
              </p>
              <h3 className={classes.cardTitle}>
                {incomeMeetings?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          <Card>
            <CardHeader color="primary" stats icon>
              <CardIcon color="primary">
                <CameraIcon />
              </CardIcon>
              <p className={classes.cardCategory}>
                Live ({nbLiveTransactions})
              </p>
              <h3 className={classes.cardTitle}>
                {incomeLives?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <RedeemIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Dons ({nbTipCount})</p>
              <h3 className={classes.cardTitle}>
                {incomeTip?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <RedeemIcon />
              </CardIcon>
              <p className={classes.cardCategory}>Dons live ({nbTipLiveCount})</p>
              <h3 className={classes.cardTitle}>
                {incomeTipLive?.toLocaleString('fr-FR')} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card>

          {/* <Card>
            <CardHeader color="rose" stats icon>
              <CardIcon color="rose">
                <WalletIcon />
              </CardIcon>
              <p className={classes.cardCategory}>
                Recharge ({nbRechargeCount})
              </p>
              <h3 className={classes.cardTitle}>
                {incomeRecharge} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card> */}

          {/* <Card>
            <CardHeader color="warning" stats icon>
              <CardIcon color="warning">
                <BlockOutlined />
              </CardIcon>
              <p className={classes.cardCategory}>Refunds ({nbRefunds})</p>
              <h3 className={classes.cardTitle}>
                {incomeRefund} {currency.symbol}
              </h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Updated at {date.toLocaleString()}
              </div>
            </CardFooter>
          </Card> */}
        </GridItem>
      </GridContainer>
    </div>
  );
}
